/**
 * 极简的全局状态管理 (替代 Redux / Context)
 * 采用单例模式和 EventTarget 进行跨组件通信
 */

class AuthStore extends EventTarget {
    private _apiKey: string | null = localStorage.getItem('tenant_api_key');
    private _token: string | null = localStorage.getItem('auth_token');
    private _username: string | null = localStorage.getItem('tenant_username');
    private _role: string | null = localStorage.getItem('tenant_role');

    get apiKey(): string | null {
        return this._apiKey;
    }

    get username(): string | null {
        return this._username;
    }

    get token(): string | null {
        return this._token;
    }

    get role(): string | null {
        return this._role;
    }

    get isLoggedIn(): boolean {
        return !!this._token;
    }

    login(token: string, apiKey: string, username: string, role: string) {
        this._token = token;
        this._apiKey = apiKey;
        this._username = username;
        this._role = role;
        localStorage.setItem('auth_token', token);
        localStorage.setItem('tenant_api_key', apiKey);
        localStorage.setItem('tenant_username', username);
        localStorage.setItem('tenant_role', role);
        this.dispatchEvent(new Event('auth-change'));
    }

    logout() {
        this._token = null;
        this._apiKey = null;
        this._username = null;
        this._role = null;
        localStorage.removeItem('auth_token');
        localStorage.removeItem('tenant_api_key');
        localStorage.removeItem('tenant_username');
        localStorage.removeItem('tenant_role');
        this.dispatchEvent(new Event('auth-change'));
    }
}

// 导出单例实例供所有组件使用
export const authStore = new AuthStore();
